import { CoverPageRouter } from '@rikstv/play-common/src/components/coverPage/CoverPageRouter';
import { KnownExternalServiceId } from '@rikstv/play-common/src/forces/externalService/externalServiceIds';

import { PlayerNoAccessDialog } from '../../../domain/player-dialog/components/PlayerNoAccessDialog';
import { PlayerSignupDialog } from '../../../domain/player-dialog/components/PlayerSignupDialog';
import { routerPaths } from '../../router/router.path';
import store from '../../store/store';

const getActivationStatus = (id: KnownExternalServiceId): { activated: boolean; activationPageUrl?: string } => {
  const activated = store.getState().user.userInfo?.externalServicesStatus[id]?.statusCode === 'Completed';
  return {
    activated,
    activationPageUrl: !activated ? routerPaths.accountExternalServicePage + '?' + id : undefined,
  };
};

export const CoverPageFactory = () => (
  <CoverPageRouter
    noAccessDialogue={PlayerNoAccessDialog}
    signupDialogue={PlayerSignupDialog}
    getExternalServiceStatus={getActivationStatus}
  />
);
